import {
  useUserRole,
  useUserActiveOrganization,
  useGetOrganizationUsersAndInvitations
} from "@/api";
import { PageHeader } from "@/components/ui/PageHeader";
import { Separator } from "@/components/ui/separator";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useState } from "react";
import OrganizationInviteUser from "../OrganizationInviteUser/OrganizationInviteUser";
import { InvitationsTable } from "./invitations-table/InvitationsColumns";
import { InvitationsDataTable } from "./invitations-table/InvitationsTable";
import { MembersDataTable } from "./members-table/MembersTable";
import { MemberTable } from "./members-table/types";

const TAB_VIEW_MEMBER = "members";
const TAB_VIEW_INVITATIONS = "invitations";

export const OrganizationMemberOverview = () => {
  const [tabView, setTabView] = useState(TAB_VIEW_MEMBER);
  const { isAdmin } = useUserRole();
  const { activeOrganization, loading } = useUserActiveOrganization();

  const {
    data,
    loading: loadingOrganizationInfo,
    error
  } = useGetOrganizationUsersAndInvitations({
    organizationSlug: activeOrganization?.slug
  });

  const memberTableData: MemberTable[] =
    (data?.organization.__typename === "Organization" &&
      data.organization.members?.map((member) => ({
        name: member.user.fullName,
        email: member.user.email,
        userId: member.user.id,
        role: member.role,
        id: member.id
      }))) ||
    [];

  const invitationsTableData: InvitationsTable[] =
    (data?.organization.__typename === "Organization" &&
      data.organization.pendingInvitations?.map((invitation) => {
        return {
          email: invitation.email,
          invited: invitation.invitedAt,
          role: invitation.role,
          id: invitation.id
        };
      })) ||
    [];

  if (loading || !activeOrganization) {
    return null;
  }
  return (
    <div>
      <PageHeader
        header="Organization members"
        subHeader={`Members of ${activeOrganization?.name}`}
      />
      <Tabs onValueChange={(val) => setTabView(val)} value={tabView}>
        <div className="flex gap-2 items-center justify-between">
          <TabsList>
            <TabsTrigger value={TAB_VIEW_MEMBER}>Members</TabsTrigger>
            <TabsTrigger value={TAB_VIEW_INVITATIONS}>
              Pending invitations
            </TabsTrigger>
          </TabsList>
          {isAdmin && (
            <OrganizationInviteUser
              setTabViewToPendingInvitations={() =>
                setTabView(TAB_VIEW_INVITATIONS)
              }
            />
          )}
        </div>

        <Separator className="my-4" />

        <TabsContent className="mt-0" value={TAB_VIEW_MEMBER}>
          <MembersDataTable
            members={memberTableData}
            error={error}
            loading={loadingOrganizationInfo}
          />
        </TabsContent>
        <TabsContent className="mt-0" value={TAB_VIEW_INVITATIONS}>
          <InvitationsDataTable
            invitations={invitationsTableData}
            error={error}
            loading={loadingOrganizationInfo}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};
